import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import NewAccountManager from "./NewAccountManager";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiTypography-root': {
        fontWeight: '700',
        fontSize: '16px',
        lineHeight: '149%',
        letterSpacing: '0.15px',
        fontFamily: "Nunito Sans, sans-serif !important",
        color: "#595959",
        textShadow: "none",

    },
    '& .MuiDialogTitle-root': {
        padding: '18px 19px 0px 18px',
    },
    '& .MuiDialog-paper': {
        maxWidth: '90%',
        minWidth: '90%',
        borderRadius: "8px",
        maxHeight: "82%",
        minHeight: "82%"
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        overflowX: "hidden",
        overflowY: "auto"
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 0 }} {...other}>
            <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                <div>
                    Suggested Accounts based on Intent
                </div>
                <div>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            display: "flex",
                            flexDirection:"flex-end",
                            right: 18,
                            padding: 0,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </div>
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function newAccountDialog(props) {

    const handleClose = () => {
        props.setOpenNewAccountDialog(false);
        // props.setIntentNewAccount(false);
    };

    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.openNewAccountDialog}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} />
                <DialogContent sx={{
                        overflow: 'hidden',   // Hide extra scroll
                }}>
                    <NewAccountManager tenantId={props.tenantId} icpSelected={props.icpSelected} setOpenNewAccountDialog={props.setOpenNewAccountDialog} openNewAccountDialog={props.openNewAccountDialog} previewData = {props.previewData} />
                </DialogContent>
            </BootstrapDialog>
        </div>
    );
}
